import { memo } from 'react'
import { useIntl } from 'react-intl'
import Usps from 'components/Common/Usps/Usps'
import useValuePropositionItems from './useValuePropositionItems'
import HomepageValueUspTile from './HomepageValueUspTile'

function HomepageValueUsps() {
  const intl = useIntl()
  const values = useValuePropositionItems()

  const heading = intl.formatMessage({
    id: '7ztxy0ldQzJhMPjI5Ks-',
    defaultMessage: 'Why you should book with us',
    description: 'Section heading for value proposition banner section',
  })

  return <Usps heading={heading}>
    {values.map(item => <HomepageValueUspTile key={item.key} item={item} />)}
  </Usps>
}

export default memo(HomepageValueUsps)
